export const ONE_OF_PAYLOADS_TEXT = 'One of those payloads:';
